<template>
  <main class="main main__viewEvent main__payEvent" role="main">
    <section v-if="show && show.showEvents?.length > 0" class="section">
      <div class="page">
        <ads-banner v-if="route.query.ads2 === 'true'" />
        <div class="row">

          <div class="col col4">
            <img :src="selectedFlyerUrl" alt="Flyer">
            <ads-banner v-if="route.query.ads === 'true'" />
<!--            <div class="thumbs">-->
<!--              <a href="#modal_video" class="video bt_modal"><img :src="selectedFlyerUrl"></a>-->
<!--              <a href="#"><img :src="selectedFlyerUrl"></a>-->
<!--              <a href="#"><img :src="selectedFlyerUrl"></a>-->
<!--            </div>-->
          </div>
          <div class="col col8">
            <h1>{{ show.name }}
              <a href="#" @click.prevent="$refs.sharingModal.openModal()"><i class="fa-solid fa-share-nodes"/></a>
            </h1>
            <div v-if="!selectedEventToBuy">
              <div v-for="(showEvent, index) in show.showEvents" :key="`showEventIndex_${index}`">
                <show-pricing-detail-component
                    v-if="index === 0 || showMoreEvents"
                    :ref="element => { pricingReferences[showEvent.id] = element }"
                    :show-event="showEvent"
                    :show="show"
                    style="margin-bottom: 20px"
                >
                  <template #action>
                    <a
                        href="#" class="bt"
                        @click.prevent="selectShowEventToBuy(showEvent.id)">{{ $t('show.startPurchase') }}<i
                        class="fa-solid fa-arrow-right"/></a>
                  </template>
                </show-pricing-detail-component>
              </div>
            </div>
            <div v-if="selectedEventToBuy && reservation === undefined">
              <div>
                <error-message>{{ $t('show.ticketsNotYetReserved') }}</error-message>
                <show-pricing-detail-component
                    ref="pricingDetailReservationStep"
                    :show="show"
                    :show-event="selectedEventToBuy"
                    :enable-purchase="true"
                    :possible-ticket-quantity="selectedShowPricingDetail?.ticketQuantity ?? buyPreference.possibleTicketQuantity"
                    :possible-show-price-id="selectedShowPricingDetail?.showPriceId ?? buyPreference.possibleShowPriceId"
                    :possible-donate-price="selectedShowPricingDetail?.donatePrice ?? buyPreference.possibleDonatePrice"
                >
                  <template #action>
                    <a href="#" class="bt" disabled @click.prevent="createReservation">{{ $t('show.reserve') }}<i
                        class="fa-solid fa-arrow-right"/></a>
                  </template>
                </show-pricing-detail-component>
                <buttons-terms-and-conditions-button ref="termsAndConditions"/>
              </div>
            </div>
            <div v-if="reservation !== undefined" style="display: block;">
              <shows-show-pricing-detail-header :show="show" :show-event="selectedEventToBuy">
                <div class="card" style="display: block;">
                  <div>
                    <div class="tickets">
                      <p>{{ $t('show.youArePurchasing') }} <strong>{{ ticketQuantity }}
                        {{ ticketQuantity > 1 ? i18n.t('show.tickets') : i18n.t('show.ticket') }}</strong>
                        <span>{{
                            i18n.t('show.purchaseDescription', {
                              price: ticketPrice,
                              fee: ticketFee
                            })
                          }}</span>
                      </p><a href="#" class="bt btG" @click.prevent="cancelReservation">{{
                        $t('show.changeTicketType')
                      }}
                      <i
                          class="fa fa-rotate-left"/></a></div>
                    <div class="tickets">
                      <countdown :reservation-token="reservation.reservationToken" :show-path="path"/>
                    </div>
                    <div v-if="show.type === 'free' || ticketPrice === 0" class="tickets">
                      <p>{{ $t('show.confirmReservation') }}</p>
                      <a class="bt" @click="confirmFreeReservation">OK!<i
                          class="fa-solid fa-check"/></a>
                    </div>
                    <div v-else class="tickets">
                      <p>{{ $t('show.totalPrice') }}<strong>${{
                          reservation.price + reservation.fee
                        }}</strong></p>
                      <a :href="reservation.paymentLink" class="bt">{{ $t('show.payNow') }}<i class="i_mp"/></a>
                    </div>
                  </div>
                </div>
              </shows-show-pricing-detail-header>
            </div>
            <h3><i class="fa-solid fa-triangle-exclamation"/> Evento solo para Mayores de 18 Años.</h3>
            <shows-valid-until-banner :starts-at="currentStartsAt" />
            <ads-banner v-if="route.query.ads3 === 'true'" />
          </div>

        </div>
      </div>
    </section>
  </main>
  <div v-if="loading" class="loading"/>
  <sharing-modal v-if="show" ref="sharingModal" :show="show"/>
  <toast ref="toastMessage">
    {{ alertMessage }}
  </toast>
</template>
<script setup lang="ts">
import {ref} from 'vue'
import type {
  ReservationResponse,
  ShowEventPublicOutput,
  ShowPublicOutput
} from '~/api/generated'
import { computed } from 'vue'
import api from '../../api'
import ShowPricingDetailComponent from '~/components/shows/ShowPricingDetailComponent.vue'
import toast from "~/components/Toast.vue";
import {useRouter} from "#imports";
import {useBuyStore} from "~/storage/buyPreference";

definePageMeta({
  layout: 'base-layout',
})

const loading = ref(true);
const selectedFlyerUrl = ref('');
const show = ref<ShowPublicOutput>({} as ShowPublicOutput);
const path = ref('');
const showMoreEvents = ref(false);
const selectedEventToBuy = ref<ShowEventPublicOutput | undefined>(undefined);
const pricingReferences = ref([]);
const selectedShowPricingDetail = ref(undefined)
const pricingDetailReservationStep = ref(undefined)
const reservation = ref<ReservationResponse | undefined>(undefined)
const toastMessage = ref()
const alertMessage = ref('')
const i18n = useI18n()
const route = useRoute();
const router = useRouter();
const ticketQuantity = ref();
const ticketPrice = ref();
const ticketFee = ref();
const buyStore = useBuyStore();
const buyPreference = buyStore.getPreference();
const total = ref();
path.value = route.params.path ?? ''
const termsAndConditions = ref(null);

const currentStartsAt = computed(() => {
  return selectedEventToBuy.value?.startsAt || show.value.showEvents?.[0]?.startsAt
})

async function onlyFetchShowData() {
  return api.Shows.getShowByPath(path.value)
      .then((response) => {
        return response.data
      })
}

const {data: showResponse} = await useAsyncData(`showResponse`, async () => {
  return await onlyFetchShowData()
})

useSeoMeta({
  title: showResponse.value?.name ?? 'Plop',
  ogTitle: showResponse.value?.name ?? 'Plop',
  description: showResponse.value?.description ?? 'Plop',
  ogDescription: showResponse.value?.description ?? 'Plop',
  ogImage: showResponse.value?.realFlyerPath ?? '',
  twitterCard: showResponse.value?.realFlyerPath ?? '',
})

onMounted(() => {
  if (showResponse.value === null) {
    throw createError({
      statusCode: 404,
      fatal: true
    })
  }
  loading.value = false
  show.value = showResponse.value as ShowPublicOutput
  selectedFlyerUrl.value = show.value.realFlyerPath ?? ''
  const buyStore = useBuyStore();
  const possibleShowEvent = buyStore.getShowEvent()
  if (possibleShowEvent !== undefined && checkIfPossibleShowEventBelongsToCurrentShow(possibleShowEvent, show.value)) {
    selectedEventToBuy.value = possibleShowEvent;
  } else {
    buyStore.$reset()
  }
})

function checkIfPossibleShowEventBelongsToCurrentShow(
    possibleShowEvent: ShowEventPublicOutput,
    show: ShowPublicOutput
): boolean {
  const allShowEvents = show.showEvents.filter((showEvent) => {
    return showEvent.id === possibleShowEvent.id
  });

  return allShowEvents?.length === 1;
}

function selectShowEventToBuy(showEventId: number) {
  selectedEventToBuy.value = pricingReferences.value[showEventId].showEvent
  selectedShowPricingDetail.value = pricingReferences.value[showEventId]
}

async function createReservation() {
  if (!termsAndConditions.value.acceptedTerms) {
    alertMessage.value = i18n.t('show.pleaseAcceptTerms')
    toastMessage.value.activate(2.5)
    return;
  }
  const isAuthenticated = await useAuthCheck()

  storePurchaseProcess();
  if (!isAuthenticated) {
    navigateTo('/auth/login');
    return;
  }

  api.Reservation.createReservation({
    quantity: pricingDetailReservationStep.value.ticketQuantity,
    showEventId: selectedEventToBuy.value.id,
    showId: show.value.id,
    showPriceId: pricingDetailReservationStep.value.showPriceId ?? null,
    donatePrice: pricingDetailReservationStep.value.donatePrice ?? null,
  })
      .catch(() => {
        alertMessage.value = i18n.t('show.noTicketsAlert')
        toastMessage.value.activate(2.5)
      })
      .then((response) => {
        ticketQuantity.value = pricingDetailReservationStep.value.ticketQuantity
        ticketPrice.value = pricingDetailReservationStep.value.ticketPrice
        ticketFee.value = pricingDetailReservationStep.value.ticketFee
        total.value = response.data.total
        reservation.value = response.data
      })
  const buyStore = useBuyStore();
  buyStore._reset()
}

function cancelReservation() {
  reservation.value = undefined
  selectedEventToBuy.value = undefined
  ticketQuantity.value = undefined
  ticketPrice.value = undefined
  total.value = undefined
}

async function confirmFreeReservation() {
  await api.Reservation.confirmReservation({
    reservationToken: reservation.value?.reservationToken
  }).then(() => {
    alertMessage.value = i18n.t('show.confirmedFreeTickets')
    toastMessage.value.activate(2.5)
    setTimeout(() => {
      router.push('/user/reservations')
    }, 3000)
  }).catch(() => {
    alertMessage.value = i18n.t('show.confirmationError')
    toastMessage.value.activate(2.5)
  })
}

function storePurchaseProcess() {
  const buyStore = useBuyStore();
  buyStore.setBuyPreference(
      selectedEventToBuy.value as ShowEventPublicOutput,
      pricingDetailReservationStep.value?.ticketQuantity,
      pricingDetailReservationStep.value?.showPriceId ?? null,
      pricingDetailReservationStep.value?.donatePrice ?? null,
  )
}
</script>